import React, { useState } from 'react';
import toast, { Toaster } from 'react-hot-toast';
import ReCAPTCHA from "react-google-recaptcha";
import axios from 'axios';
import useMediaQuery from "../hooks/useMediaQuery";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const CAPTCHA_KEY = process.env.REACT_APP_CAPTCHA_KEY;
const ContactUs = () => {

    const [enquiryFormData, setEnquiryFormData] = useState({
        name: '',
        email: '',
        mobile: '',
        purpose: '',
        location: ''
    });

    const handleEnquiryFormDataChange = (e) => {
        let { name, value } = e.target;
        setEnquiryFormData({ ...enquiryFormData, [name]: value });
    }

    const onEnquirySubmit = (event) => {
        const { mobile, email, name, message, purpose } = enquiryFormData;

        if (name === '') {
            toast.error("Please enter your full name to proceed");
            event.preventDefault();
            return false;
        }

        if (mobile === '+91 ' || mobile.length !== 14) {
            
            toast.error("Please enter a valid Mobile Number");
            event.preventDefault();
            return false;
        }

        if (mobile === '+91 ' || mobile.length !== 14) {
            toast.error("Enter a valid Mobile Number to apply");
            event.preventDefault();
            return false;
        }

        if (email === '') {
            toast.error("Please enter a valid Email address");
            event.preventDefault();
            return false;
        }
        if (message === '') {
            toast.error("Please enter a valid enquiry message");
            event.preventDefault();
            return false;
        }
        if (purpose === '') {
            toast.error("Please choose a purpose of your enquiry");
            event.preventDefault();
            return false;
        }
        event.preventDefault();

        axios.post(`${API_BASE_URL}/enquiry`, enquiryFormData).then((response => {
            toast.success('Enquiry submitted successfully!');
            document.getElementById("enquiry-form").reset();
            setEnquiryFormData({
                name: '',
                email: '',
                mobile: '',
                purpose: '',
                location: ''
            })
        }));
    }

    const onCaptchaChange = (e) => {
    }

    const isDesktop = useMediaQuery('(min-width:1280px)');

    return (
        <>
            <Toaster
                position="bottom-center"
                reverseOrder={false}
            />
            <div className='relative'>
                <div className="md:block hidden"> 
                    <img
                        className="object-cover w-full object-right home-img"
                        src="/assets/static/images/contact us-02.jpg"
                        alt=""
                    />
                </div>
                <div className="md:hidden block">
                    <img
                        className="object-fit object-right w-screen banner-img"
                        src="/assets/static/images/contact us-02-sm.jpg"
                        alt=""
                    />
                </div>
            </div>
            <form onSubmit={onEnquirySubmit} id="enquiry-form">
                <div id="enquiry" className='lg:scroll-m-32 scroll-m-16 flex flex-col justify-center text-center bg-dinshaw-green items-center h-full w-full py-4 lg:py-12 px-6' >

                    <div className='lg:w-3/4'>
                        <h2 className="text-dinshaw-yellow mb-2 lg:mb-8">
                            Got any queries or questions?<br />
                            We’ll be happy to help!
                        </h2>
                        <div className='grid grid-cols-1 lg:grid-cols-2 lg:gap-32'>
                            <div className='flex flex-col'>
                                <input
                                    type="text"
                                    required
                                    name="name"
                                    className="px-4 lg:px-8 py-3 mt-4 lg:mt-6 dinshaw-fc-text"
                                    placeholder="Name*"
                                    onChange={handleEnquiryFormDataChange}
                                />
                                <input
                                    type="email"
                                    required
                                    name="email"
                                    className="px-4 lg:px-8 py-3 mt-4 lg:mt-6 dinshaw-fc-text"
                                    placeholder="Email*"
                                    onChange={handleEnquiryFormDataChange}
                                />
                                <input
                                    type="tel"
                                    required
                                    className="px-4 lg:px-8 py-3 mt-4 lg:mt-6 dinshaw-fc-text"
                                    placeholder="Mobile*"
                                    name="mobile"
                                    maxLength={14}
                                    onChange={(e) => {
                                        let input = e.target.value;
                                        if (input.length === 1) {
                                            input = input.replace(/\D/g, "");
                                            e.target.value = "+91 " + input;
                                        } else {
                                            input = input.substr(4).replace(/\D/g, "");
                                            e.target.value = "+91 " + input
                                        }
                                        handleEnquiryFormDataChange(e);
                                    }}
                                />
                                <select className="form-select px-4 lg:px-8 py-3 mt-6 dinshaw-fc-select" placeholder='Purpose*' required name="purpose" onChange={handleEnquiryFormDataChange}>
                                    <option className='text-gray-500' value="" disabled selected>Purpose*</option>
                                    <option value="Feedback/Suggestions">Feedback/Suggestions</option>
                                    <option value="Trade Inquiries">Trade Inquiries</option>
                                </select>
                                <input
                                    type="text"
                                    required
                                    className="px-4 lg:px-8 py-3 mt-4 lg:mt-6 dinshaw-fc-text"
                                    placeholder="Location*"
                                    name="location"
                                    onChange={handleEnquiryFormDataChange}
                                />
                            </div>

                            <div className='flex flex-col'>
                                <textarea
                                    type="text"
                                    required
                                    rows="4"
                                    className="px-4 lg:px-8 py-3 mt-4 lg:mt-6 dinshaw-fc-text-area"
                                    placeholder="Message*"
                                    name="message"
                                    onChange={handleEnquiryFormDataChange}
                                />

                                <div className='my-2'>
                                    <ReCAPTCHA size='normal' sitekey={CAPTCHA_KEY} onChange={onCaptchaChange} />
                                </div>

                                <div className='my-10 lg:mt-12 flex lg:justify-end lg:items-end items-center justify-center'>
                                    <button className="mt-2 py-3 px-12 text-white rounded-full bg-dinshaw-theme text-xl">Submit</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <div id="contact" className='lg:scroll-m-32 scroll-m-16 relative' style={{ minHeight: !isDesktop ? '70vh': 'auto', height: !isDesktop ? '70vh': 'auto'}}>
                <img style={{ minHeight: !isDesktop ? '70vh': 'auto',  height: !isDesktop ? '90vh': 'auto'}}
                    className="h-full object-cover object-left w-full hidden lg:block"
                    src="/assets/static/images/contact us-01.jpg"
                    alt=""
                />

                <img style={{ minHeight: !isDesktop ? '70vh': 'auto',  height: !isDesktop ? '70vh': 'auto'}}
                    className="h-full object-cover object-left w-full lg:hidden block" 
                    src="/assets/static/images/contact us-01.jpg"
                    alt=""
                />
                <div className='absolute top-0 h-full lg:left-24 left-8'>
                    <div className='relative h-full flex flex-col justify-center items-center text-center'>
                        <div>
                            <h2 className='text-dinshaw-theme'>Contact Us</h2>
                            <div className='mt-4 lg:mt-6 font-bold'>
                                <p className='text-dinshaw-secondary'>Head Office</p>
                                <p className='text-black'>Dinshaw’s Dairy Foods Pvt. Ltd.,</p>
                                <p className='text-black'>Gorewada Road, Borgaon, Gittikhadan,</p>
                                <p className='text-black'>Nagpur – 440013,</p>
                                <p className='text-black'>Maharashtra, India</p>
                            </div>
                            <div className='mt-4 lg:mt-6 font-bold'>
                                <p className='text-dinshaw-secondary'>Corporate Office</p>
                                <p className='text-black'>Dinshaw’s GDL Office</p>
                                <p className='text-black'>Banaz, Byramji Town, Nagpur – 440013,</p>
                                <p className='text-black'>Maharashtra, India</p>
                            </div>
                            <div className='mt-2 lg:mt-4'>
                                <p className='text-black font-bold'>Toll-free No.: 1800-120-9999</p>
                            </div>
                            <div className='px-8'>
                                <p className='text-black text-xs lg:text-base font-bold'>(All days from 9 am to 6 pm <br/> except Sundays & Public Holidays)</p>
                            </div>
                            <div className='mt-2 lg:mt-4'>
                                <p className='text-black font-bold'>Email: customerdelight@dinshaws.co.in</p>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}

export default ContactUs;